import * as Highcharts from 'highcharts';
import * as jQuery from 'jquery';
import * as moment from 'moment';
import { stringify } from 'querystring';
import * as _ from 'underscore';

import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild
} from '@angular/core';
import { NguCarousel, NguCarouselConfig, NguCarouselStore } from '@ngu/carousel';

@Component({
	selector: 'app-creative-performance-graph',
	styleUrls: ['./creative-performance-graph.component.css'],
	templateUrl: './creative-performance-graph.component.html'
})
export class CreativePerformanceGraphComponent implements OnInit, OnChanges, OnDestroy {
	@ViewChild('graphArea', { static: true }) graphElement: ElementRef;
	@ViewChild('carousel') carousel: NguCarousel<any>;

	@Input() legendData: any;
	@Input() showalldatesdata: boolean = false;
	@Input() graphData: any;
	@Input() customLegendData;
	@Input() name: any;
	@Input() legendDisabled;
	@Input() svgWidth;
	@Input() svgHeight;
	@Input() ticksRotation;
	@Input() chartType;
	@Input() creativeLegendEnabled;
	@Input() markerEnabled;
	@Input() seriesName;
	@Input() enableCustomLegend;
	@Input() sectiontitle;
	@Input() findRVersion;

	// tslint:disable-next-line: prefer-output-readonly
	@Output() legendSelected = new EventEmitter<any>();
	// tslint:disable-next-line: prefer-output-readonly
	@Output() mouseOverChart = new EventEmitter<any>();
	// tslint:disable-next-line: prefer-output-readonly
	@Output() mouseOutChart = new EventEmitter<any>();

	public defaultCount = 5;
	public stepCount;
	public maxPoints = 50;
	public dataLength = 0;
	public leftExtreme = 0;
	public rightExtreme = 0;
	public chartObj;
	public carouselOne: NguCarouselConfig;
	public carouselToken: string;
	public selectedMetric: any;
	public creativeName: string;

	constructor() {
		this.carouselOne = {
			grid: { xs: 3, sm: 3, md: 3, lg: 3, all: 0 },
			loop: false,
			point: {
				visible: false
			},
			slide: 1,
			speed: 600,
			touch: true
		};
	}

	ngOnInit(): void {
		this.legendDisabled = this.legendDisabled === true ? true : false;
		this.creativeName = this.sectiontitle.split(' ')[0];
		this.findRVersion = this.findRVersion ? this.findRVersion : '';
	}

	initDataFn(key: NguCarouselStore): void {
		this.carouselToken = key.token;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!_.isEmpty(this.graphData)) {
			this.stepCount = this.calculateStepCount();
			this.dataLength = this.graphData.categories.length - 1;
			this.creativeName = this.sectiontitle.split(' ')[0];
			this.drawGraph();
		}
	}

	selectLegendItem(legendItem: any): void {
		this.legendSelected.emit(legendItem);
	}
	getSelectedLegend(): any[] {
		return _.filter(this.legendData, (obj: any) => {
			return obj['selected'] === true;
		});
	}
	drawGraph(): void {
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		this.selectedMetric = this.getSelectedLegend();
		Highcharts.setOptions({
			lang: {
				thousandsSep: ','
			}
		});
		this.chartObj = Highcharts.chart(
			this.graphElement.nativeElement,
			{
				chart: {
					events: {
						click: (event) => {
							this.clickEvent(event);
						}
					},
					height: self.svgHeight || 400,
					margin: [40, 80, 70, 80],
					type: self.chartType || 'area',
					zoomType: 'xy'
				},
				credits: {
					enabled: false
				},
				legend: {
					enabled: false,
					itemWidth: 180,
					layout: 'horizontal',
					maxHeight: 50,
					y: 20
				},
				plotOptions: {
					area: {
						marker: {
							enabled: false,
							radius: 2,
							states: {
								hover: {
									enabled: true
								}
							},
							symbol: 'circle'
						}
					},
					series: {
						marker: {
							enabled: this.findRVersion !== 'R4' && self.markerEnabled ? true : false,
							radius: self.chartType === 'areaspline' ? 4 : 2,
							symbol: self.chartType === 'areaspline' ? 'circle' : undefined
						},
						point: {
							events: {
								mouseOut: (event) => {
									this.mouseOutEvent(event);
								},
								mouseOver: (event) => {
									this.mouseOverEvent(event);
								}
							}
						},
						states: {
							inactive: {
								opacity: 1
							}
						}
					}
				},
				series: this.graphData.series,
				subtitle: {
					text: null
				},
				title: {
					text: null
				},
				tooltip: {
					backgroundColor: self.chartType === 'areaspline' ? '#000' : 'rgba(255,255,255, 0.6)',
					headerFormat:
						self.chartType === 'areaspline'
							? `<span style="font-size: 10px;color: #FFF;">{point.key}</span><br/>`
							: `<span style="font-size: 10px">{point.key}</span><br/>`,
					pointFormat:
						self.chartType === 'areaspline'
							? // tslint:disable-next-line: prefer-template
							  '<span style="color:{point.color};">●</span><span style="color: #FFF;"><b>{point.y}</b>{point.value}  ' +
							  this.creativeName +
							  ' ' +
							  this.updateTitle(self.selectedMetric[0].value) +
							  '</span><br/>'
							: `<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>`,
					useHTML: true
				},
				xAxis: {
					categories: this.graphData.categories,
					labels: {
						formatter(): string {
							return self.findRVersion !== 'R4' ? moment(this.value).format('D-MM-YYYY'): moment(this.value).format('MM/DD/YYYY');
						},
						rotation: self.ticksRotation ? parseInt(self.ticksRotation, 10) : -45,
						step: this.stepCount
					},
					tickPositioner(): any {
						const positions = [];
						const min = Math.floor(this.min);
						const max = Math.ceil(this.max);
						let tick = min;
						const increment = Math.ceil((max - min) / 30);

						for (; tick < max; tick += increment) {
							positions.push(tick);
						}
						positions.push(max);
						return positions;
					},
					type: 'datetime'
				},
				yAxis: {
					labels: {
						formatter(): string {
							return String(this.value);
						}
					},
					title: {
						text: null
					}
				}
			},
			(chart: any) => {
				// on complete
				function noop(): void {}
				if (!this.showalldatesdata) {
					if (this.dataLength > this.maxPoints) {
						this.leftExtreme = this.dataLength - this.maxPoints > 0 ? this.dataLength - this.maxPoints : 0;
						this.rightExtreme = this.dataLength;
						chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
						if (!self.svgHeight) {
							chart.renderer
								.button('<', chart.plotLeft - 60, chart.plotHeight + chart.plotTop, noop)
								.attr({ id: `id_left_${this.name}` })
								.addClass('left_' + this.name)
								.add();
							chart.renderer
								.button('>', chart.plotLeft + chart.plotWidth + 30, chart.plotHeight + chart.plotTop, noop)
								.attr({ id: `id_right_${this.name}` })
								.addClass('right_' + this.name)
								.add();
							jQuery('.left_' + this.name).click(() => {
								if (this.leftExtreme > 0) {
									this.rightExtreme = this.leftExtreme - 1;
									this.leftExtreme = this.leftExtreme - this.maxPoints > 0 ? this.leftExtreme - this.maxPoints : 0;
									chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
								}
							});
							jQuery('.right_' + this.name).click(() => {
								if (this.rightExtreme < this.dataLength) {
									this.leftExtreme = this.rightExtreme + 1;
									this.rightExtreme =
										this.leftExtreme + this.maxPoints > this.dataLength
											? this.dataLength
											: this.leftExtreme + this.maxPoints;
									chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
								}
							});
						}
					}
				}
			}
		);
	}

	calculateStepCount(): number {
		if (this.maxPoints <= this.defaultCount) {
			return 1;
		}
		if (this.ticksRotation === '0') {
			return 10;
		}
		return Math.ceil(this.maxPoints / (this.defaultCount * 2));
	}

	mouseOverEvent(eventObj: any): void {
		const index = eventObj.target.series.index;
		this.mouseOverChart.emit({ index, toggle: true });
	}

	mouseOutEvent(eventObj: any): void {
		const index = eventObj.target.series.index;
		this.mouseOutChart.emit({ index, toggle: false });
	}

	clickEvent(eventObj: any): void {}
	updateTitle(word: string): string {
		if (!word) {
			return word;
		}
		if (word === 'adInteractions') {
			return 'Ad Interactions';
		}
		return word[0].toUpperCase() + word.substr(1).toLowerCase();
	}

	updateLegendArray(legendItem: any, index: number): void {
		this.customLegendData[index].active = !this.customLegendData[index].active;
		this.updateSeriesObj();
	}

	updateSeriesObj(): void {
		for (let i = 0; i < this.customLegendData.length; i++) {
			if (this.customLegendData[i].active) {
				this.chartObj.series[i].show();
			} else {
				this.chartObj.series[i].hide();
			}
		}
	}

	ngOnDestroy(): void {
		if (this.chartObj) {
			this.chartObj.destroy();
		}
	}
}
